import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
export default new Vuex.Store({
    // 赋值 setToken : actions =>setToken
    // this.$store.dispatch('setToken', {})
    // 取值 token : getters=> token
    // this.$store.getters.token
    state: {
        isPC: sessionStorage.getItem('isPC') || false,
    },
    getters: {
        isPC: state => state.isPC,
    },
    mutations: {
        SETIsPC(state, data) {
            sessionStorage.setItem('isPC', data);
            state.isPC = data
            console.log(state.isPC)
        },
    },
    actions: {
        setIsPC({
            commit
        }, data) {
            commit("SETIsPC", data)
        },
    },
    modules: {}
})


// WEBPACK FOOTER //
// ./src/store/index.js